import { Input } from '@verlo/shared/components/ui/input';
import { Checkbox } from '@verlo/shared/components/ui/checkbox';
import { theirs } from '../../lib/orders';

// Where an order goes when the supplier has no email for orders (Martin, 27 Oct): type one
// here, and either save it to their account (ticked) or send to it this once. The tick stays
// greyed out until what's typed is an email address. The page sends `{ to }` for a one-off,
// or saves it to the supplier first.

export const looksLikeEmail = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v || '').trim());

export default function OrderEmailField({ supplierName, value, onChange, keep, onKeep, testId = 'order-email', className = '' }) {
  const ok = looksLikeEmail(value);
  const bad = value.trim() && !ok;
  return (
    <div className={`space-y-1.5 ${className}`}>
      <Input type="email" value={value} onChange={(e) => onChange(e.target.value)} placeholder="e.g. orders@supplier.co.uk"
        aria-label={`${theirs(supplierName)} email for orders`} aria-invalid={bad || undefined} className="h-9 bg-white" data-testid={`${testId}-input`} />
      {bad && <p className="text-[12px] text-signal-stop">That doesn&apos;t look like an email address.</p>}
      <label className={`flex items-center gap-2 text-[12.5px] ${ok ? 'text-ink-soft' : 'text-ink-faint'}`}>
        <Checkbox checked={keep} disabled={!ok} onCheckedChange={(c) => onKeep(c === true)} data-testid={`${testId}-keep`}
          className="border-hairline-strong data-[state=checked]:border-verlo data-[state=checked]:bg-verlo data-[state=checked]:text-white" />
        Save this email address to the account
      </label>
      {!keep && ok && <p className="text-[12px] text-ink-faint">Just this order goes there; {supplierName} stays with no email for orders.</p>}
    </div>
  );
}
